// extracted by mini-css-extract-plugin
export var arrowButton = "industry-carousel-module--arrowButton--6fbd5";
export var carouselContainer = "industry-carousel-module--carouselContainer--5e145";
export var carouselContainerSmall = "industry-carousel-module--carouselContainerSmall--4c04d";
export var exploreDeco = "industry-carousel-module--exploreDeco--5b6fb";
export var exploreDecoImage = "industry-carousel-module--exploreDecoImage--c40c5";
export var industryCard = "industry-carousel-module--industryCard--61841";
export var industryCarousel = "industry-carousel-module--industryCarousel--54e1c";
export var visuallyHidden = "industry-carousel-module--visuallyHidden--8b99f";